import i18n from 'i18next';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import XhrBackend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
export const baseUrl = window.apiroot;
const checki18n = () => {
    let msg42 = new URLSearchParams(location.search).get('msg') === '42';
    return (i18n
        // load translation using xhr -> see /public/locales
        // learn more: https://github.com/i18next/i18next-xhr-backend
        .use(Backend)
        .use(initReactI18next)
        // init i18next
        // for all options read: https://www.i18next.com/overview/configuration-options
        .init({
        debug: false,
        backend: {
            backends: window.devmode || msg42 ? [XhrBackend] : [LocalStorageBackend, XhrBackend],
            backendOptions: window.devmode || msg42
                ? [
                    {
                        loadPath: `${baseUrl}/Translations-Bundle?locale={lng}${msg42 ? '&msg=42' : ''}`,
                    },
                ]
                : [
                    {
                        prefix: 'i18next_res_',
                        expirationTime: 30 * 60 * 1000, // 30 minutes
                    },
                    {
                        loadPath: `${baseUrl}/Translations-Bundle?locale={lng}`,
                    },
                ],
        },
        lng: document.documentElement.lang,
        fallbackLng: false,
        load: 'currentOnly',
        interpolation: {
            escapeValue: false,
            prefix: '{',
            suffix: '}',
        },
        cache: {
            // turn on or off
            enabled: true,
            // prefix for stored languages
            prefix: 'i18n_',
            // expiration
            expirationTime: 60 * 60 * 1000,
            // language versions
            //versions: {}
        },
    }));
};
export default checki18n();
